// extracted by mini-css-extract-plugin
export default {"selection":"ManageSelection_selection__GL5urY1T","countSelected":"ManageSelection_countSelected__qkTBkxS2"};